import { service } from 'services';
import { actions } from 'redux/local';
import { ROUTE } from 'constant';

export const getProvisioningItems = () => JSON.parse(window.localStorage.getItem('provisioningItems')) || [];

export const updateProvisioningItem = ({ id, item }) => {
  const items = getProvisioningItems();
  items.forEach((itemInner) => {
    if (id === itemInner.id) {
      itemInner.status = item.status;
      itemInner.message = item.message;
    }
  });
  window.localStorage.setItem('provisioningItems', JSON.stringify(items));
};

export const deleteProvisioningItem = (id) => {
  const items = getProvisioningItems();
  const index = items.findIndex(({ id: idInner }) => id === idInner);
  items.splice(index, 1);
  window.localStorage.setItem('provisioningItems', JSON.stringify(items));
};

export const addProvisioningItem = (item) => {
  const items = getProvisioningItems() || [];
  items.push(item);
  window.localStorage.setItem('provisioningItems', JSON.stringify(items));
  actions.provisioning.setProvisioningItems({ provisioningItems: items });
};

export const setProvisioningRequestId = async ({ action = '', name = '', url = '' }) => {
  if (url) {
    const result = await service.common.getUrl({ url });
    const { metadata = {} } = result || {};
    const { status, message, targets = [] } = metadata;
    const [targetItem = {}] = targets;
    const { status: itemStatus = '', target = {} } = targetItem;
    const { id, type, href: itemUrl } = target;

    const object = {
      action, status, itemStatus, message, url, itemUrl, id, type, date: new Date(),
    };

    if (!name && type !== 'nic' && type !== 'ipblock' && type !== 'backupunit') {
      const resultItem = await service.common.getUrl({ url: itemUrl });
      const { properties } = resultItem;
      if (!properties) object.name = type;
      else object.name = properties?.name;
    } else {
      object.name = name;
    }
    addProvisioningItem(object);
  }

  return 0;
};

export const getProvisioningWatches = () => JSON.parse(window.localStorage.getItem('provisioningWatches')) || [];

export const addProvisioningWatches = (item) => {
  const items = getProvisioningWatches() || [];
  items.push({ id: item.length + 1, ...item });
  window.localStorage.setItem('provisioningWatches', JSON.stringify(items));
};

export const deleteProvisioningWatches = (id) => {
  const items = getProvisioningWatches();
  const index = items.findIndex(({ id: idInner }) => id === idInner);
  items.splice(index, 1);
  window.localStorage.setItem('provisioningWatches', JSON.stringify(items));
};

export const reFetchAndDispatchItem = () => {
  const { pathname } = window.location;
  const routes = [
    {
      path: ROUTE.DASHBOARD.CONTRACTS.pathRegex,
      trigger: () => actions.contract.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.STORAGE.pathRegex,
      trigger: () => {
        const [, dcId = '', id = ''] = pathname.match(ROUTE.DASHBOARD.STORAGE.pathRegex) || [];
        actions.storage.get({ dcId, id });
      },
    },
    {
      path: ROUTE.DASHBOARD.LAN.pathRegex,
      trigger: () => {
        const [, dcId = '', id = ''] = pathname.match(ROUTE.DASHBOARD.LAN.pathRegex) || [];
        actions.lan.get({ dcId, id });
      },
    },
    {
      path: ROUTE.DASHBOARD.NIC.pathRegex,
      trigger: () => {
        const [, dcId = '', serverId = '', id = ''] = pathname.match(ROUTE.DASHBOARD.NIC.pathRegex) || [];
        actions.nic.get({ dcId, serverId, nicId: id });
        actions.nic.flowlogGetAll({ dcId, nicId: id, serverId });
      },
    },
    {
      path: ROUTE.DASHBOARD.SERVER.pathRegex,
      trigger: () => {
        const [, dcId = '', id = ''] = pathname.match(ROUTE.DASHBOARD.SERVER.pathRegex) || [];
        actions.server.get({ dcId, id });
      },
    },
    {
      path: ROUTE.DASHBOARD.LOAD_BALANCER.pathRegex,
      trigger: () => {
        const [, dcId = '', id = ''] = pathname.match(ROUTE.DASHBOARD.LOAD_BALANCER.pathRegex) || [];
        actions.loadbalancer.get({ dcId, id });
      },
    },
    {
      path: ROUTE.DASHBOARD.ALB_FORWARDING_RULE.pathRegex,
      trigger: () => {
        const [, dcId = '', id = '', forwardingRuleId] = pathname.match(ROUTE.DASHBOARD.ALB_FORWARDING_RULE.pathRegex) || [];
        actions.applicationLoadbalancer.getForwardingRule({ dcId, forwardingRuleId, id });
      },
    },
    {
      path: ROUTE.DASHBOARD.APPLICATION_LOAD_BALANCER.pathRegex,
      trigger: () => {
        const [, dcId = '', id = ''] = pathname.match(ROUTE.DASHBOARD.APPLICATION_LOAD_BALANCER.pathRegex) || [];
        actions.applicationLoadbalancer.get({ dcId, id });
      },
    },
    {
      path: ROUTE.DASHBOARD.NLB_FORWARDING_RULE.pathRegex,
      trigger: () => {
        const [, dcId = '', id = '', forwardingRuleId] = pathname.match(ROUTE.DASHBOARD.NLB_FORWARDING_RULE.pathRegex) || [];
        actions.networkLoadbalancer.getForwardingRule({ dcId, forwardingRuleId, id });
      },
    },
    {
      path: ROUTE.DASHBOARD.NETWORK_LOAD_BALANCER.pathRegex,
      trigger: () => {
        const [, dcId = '', id = ''] = pathname.match(ROUTE.DASHBOARD.NETWORK_LOAD_BALANCER.pathRegex) || [];
        actions.networkLoadbalancer.get({ dcId, id });
      },
    },
    {
      path: ROUTE.DASHBOARD.NAT_GATEWAY.pathRegex,
      trigger: () => {
        const [, dcId = '', id = ''] = pathname.match(ROUTE.DASHBOARD.NAT_GATEWAY.pathRegex) || [];
        actions.natGateway.get({ dcId, id });
      },
    },
    {
      path: ROUTE.DASHBOARD.DATA_CENTERS.pathRegex,
      trigger: () => actions.dataCenter.getAll({}),
    },
    {
      path: ROUTE.DASHBOARD.DATA_CENTER.pathRegex,
      trigger: () => {
        const [, id = ''] = pathname.match(ROUTE.DASHBOARD.DATA_CENTER.pathRegex) || [];
        actions.dataCenter.get({ id });
      },
    },
    {
      path: ROUTE.DASHBOARD.SSH_KEYS.pathRegex,
      trigger: () => actions.sshKey.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.IMAGES.pathRegex,
      trigger: () => actions.images.getUploadedImages(),
    },
    {
      path: ROUTE.DASHBOARD.KUBERNETES.pathRegex,
      trigger: () => actions.kubernetes.cluster.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.KUBERNETES_NODEPOOL.pathRegex,
      trigger: () => {
        const [, k8sId = '', nodepoolId = ''] = pathname.match(/\/kubernetes\/(.+)\/nodepool\/(.+)$/) || [];
        if (k8sId) actions.kubernetes.nodepool.get({ clusterId: k8sId, id: nodepoolId });
      },
    },
    {
      path: ROUTE.DASHBOARD.KUBERNETES_CLUSTER.pathRegex,
      trigger: () => {
        const [, k8sId = ''] = pathname.match(/\/kubernetes\/(.+)$/) || [];
        if (k8sId) actions.kubernetes.cluster.get({ id: k8sId });
      },
    },
    {
      path: ROUTE.DASHBOARD.USER_MANAGEMENT.pathRegex,
      trigger: () => actions.user.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.USER_MANAGEMENT_USERS.pathRegex,
      trigger: () => actions.user.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.USER_MANAGEMENT_USER.pathRegex,
      trigger: () => {
        const [, userId = ''] = pathname.match(/\/user\/(.+)$/) || [];
        if (userId) actions.user.get({ userId });
      },
    },
    {
      path: ROUTE.DASHBOARD.USER_MANAGEMENT_GROUPS.pathRegex,
      trigger: () => actions.group.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.USER_MANAGEMENT_GROUP.pathRegex,
      trigger: () => {
        const [, groupId = ''] = pathname.match(/\/group\/(.+)$/) || [];
        if (groupId) {
          actions.group.get({ id: groupId });
          actions.user.getAll();
          actions.group.getUsers({ groupId });
          actions.group.getResouces({ groupId });
        }
      },
    },
    {
      path: ROUTE.DASHBOARD.GRPAH.pathRegex,
      trigger: () => {
        const [, dcId = ''] = pathname.match(ROUTE.DASHBOARD.GRPAH.pathRegex) || [];
        if (dcId) actions.monitoring.action.get({ id: dcId });
      },
    },
    {
      path: ROUTE.DASHBOARD.IPS.pathRegex,
      trigger: () => actions.ip.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.BACKUP_UNIT.pathRegex,
      trigger: () => actions.backupUnits.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.MONITORING_ACTIONS.pathRegex,
      trigger: () => actions.monitoring.action.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.MONITORING_ACTION.pathRegex,
      trigger: () => {
        const [, id = ''] = pathname.match(ROUTE.DASHBOARD.MONITORING_ACTION.pathRegex) || [];
        if (id) actions.monitoring.action.get({ id });
      },
    },
    {
      path: ROUTE.DASHBOARD.MONITORING_ALARMS.pathRegex,
      trigger: () => actions.monitoring.alarm.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.MONITORING_ALARM.pathRegex,
      trigger: () => {
        const [, id = ''] = pathname.match(ROUTE.DASHBOARD.MONITORING_ALARM.pathRegex) || [];
        if (id) actions.monitoring.alarm.get({ id });
      },
    },
    {
      path: ROUTE.DASHBOARD.AUTO_SCALING.pathRegex,
      trigger: () => {
        actions.autoScaling.group.getAll();
        actions.autoScaling.template.getAll();
      },
    },
    {
      path: ROUTE.DASHBOARD.AUTO_SCALING_GROUP.pathRegex,
      trigger: () => {
        const [, id = ''] = pathname.match(ROUTE.DASHBOARD.AUTO_SCALING_GROUP.pathRegex) || [];
        if (id) actions.autoScaling.group.get({ id });
      },
    },
    {
      path: ROUTE.DASHBOARD.DATABASES.pathRegex,
      trigger: () => {
        actions.database.getQuota();
        actions.database.postgresql.getAll();
        actions.database.mongodb.getAll();
      },
    },
    {
      path: ROUTE.DASHBOARD.DBAAS_POSTGRESQL.pathRegex,
      trigger: () => {
        const [, id = ''] = pathname.match(ROUTE.DASHBOARD.DBAAS_POSTGRESQL.pathRegex) || [];
        if (id) actions.database.postgresql.get({ id });
      },
    },
    {
      path: ROUTE.DASHBOARD.DBAAS_MONGODB.pathRegex,
      trigger: () => {
        const [, id = ''] = pathname.match(ROUTE.DASHBOARD.DBAAS_MONGODB.pathRegex) || [];
        if (id) actions.database.mongodb.get({ id });
      },
    },
    {
      path: ROUTE.DASHBOARD.TARGET_GROUPS.pathRegex,
      trigger: () => actions.targetGroup.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.TARGET_GROUP.pathRegex,
      trigger: () => {
        const [, id = ''] = pathname.match(ROUTE.DASHBOARD.TARGET_GROUP.pathRegex) || [];
        if (id) actions.targetGroup.get({ id });
      },
    },
    {
      path: ROUTE.DASHBOARD.CERTIFICATE_MANAGER.pathRegex,
      trigger: () => actions.certificateManager.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.CONTAINER_REGISTRY_LIST.pathRegex,
      trigger: () => actions.containerRegistry.registry.getAll(),
    },
    {
      path: ROUTE.DASHBOARD.CONTAINER_REGISTRY_SINGLE.pathRegex,
      trigger: () => {
        const [, id = ''] = pathname.match(ROUTE.DASHBOARD.CONTAINER_REGISTRY_SINGLE.pathRegex) || [];
        if (id) actions.containerRegistry.registry.get({ id });
        if (id) actions.containerRegistry.token.getAll({ registryId: id });
      },
    },
  ];
  const route = routes.find(({ path }) => pathname.match(path));
  if (route) {
    const { trigger } = route;
    if (trigger) trigger();
  }
};

export const filterRequestForProvisioningItem = ({ action, response, baseUrl }) => {
  const provisioning = { action, name: '', url: '' };
  const { headers } = response;
  provisioning.url = headers.get('location');

  if (provisioning.url && baseUrl !== 'monitoring' && baseUrl !== 'autoscaling' && baseUrl !== 'containerRegistry') {
    return setProvisioningRequestId(provisioning);
  }

  return {};
};
